<div class="mdsf-quiz-container scrollable">
  <div class="editor-input">
    @if ({correctPercentage: trainingSharedFacade.selectedCorrectPercentageSlideResults$ | async, wrongPercentage: (trainingSharedFacade.selectedWrongPercentageSlideResults$ | async), emptyPercentage: (trainingSharedFacade.selectedEmptyPercentageSlideResults$ | async)}; as trainingResultData) {
      <section>
        <h1 translate="your_quiz_result"></h1>
        <p translate="you_correctly_answered"
        [translateParams]="{answeredRightPercent: trainingResultData.correctPercentage}"></p>
        <div class="progress mb-2">
          <!-- Correct -->
          @if (trainingResultData.correctPercentage) {
            <div
              class="progress-bar bg-success"
              role="progressbar"
              [style.width]="trainingResultData.correctPercentage + '%'"
              [attr.aria-valuenow]="trainingResultData.correctPercentage"
              aria-valuemin="0"
              aria-valuemax="100">
              {{ trainingResultData.correctPercentage }}%
            </div>
          }
          <!-- Wrong -->
          @if (trainingResultData.wrongPercentage) {
            <div
              class="progress-bar bg-danger"
              role="progressbar"
              [style.width]="trainingResultData.wrongPercentage + '%'"
              [attr.aria-valuenow]="trainingResultData.wrongPercentage"
              aria-valuemin="0"
              aria-valuemax="100">
              {{ trainingResultData.wrongPercentage }}%
            </div>
          }
          <!-- Empty -->
          @if (trainingResultData.emptyPercentage) {
            <div
              class="progress-bar bg-empty"
              role="progressbar"
              [style.width]="trainingResultData.emptyPercentage + '%'"
              [attr.aria-valuenow]="trainingResultData.emptyPercentage"
              aria-valuemin="0"
              aria-valuemax="100">
              {{ trainingResultData.emptyPercentage }}%
            </div>
          }
        </div>
        <p>
          @if (trainingResultData.correctPercentage) {
            <span class="mr-2"
              >
              <span class="badge badge-success">&nbsp;</span>
              {{'correct'|translate}}
            </span>
          }
          @if (trainingResultData.wrongPercentage) {
            <span class="mr-2"
              >
              <span class="badge badge-danger">&nbsp;</span>
              {{'wrong'|translate}}
            </span>
          }
          @if (trainingResultData.emptyPercentage) {
            <span class="mr-2"
              >
              <span class="badge badge-empty">&nbsp;</span>
              {{'blank'|translate}}
            </span>
          }
        </p>
        <div class="btn-group">
          <button class="mdsf-btn mdsf-btn-primary"
            (click)="trainingSharedFacade.requestGoToStart()"
            translate="finish_quiz">
          </button>
        </div>
      </section>
    }
  </div>
</div>
